import FileType from '~/client/src/shared/enums/FileType'
import IFilePreviewProperties from '~/client/src/shared/interfaces/IFilePreviewProperties'

import { Attachment } from '../core/protocol/types'

export function toImagePreviewFiles(
  attachments: readonly Attachment[],
): IFilePreviewProperties[] {
  return attachments.map(attachment => ({
    fileUrl: attachment.url,
    fileType: FileType.Image,
    fileName: attachment.fileName,
  }))
}
